import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import VeeValidate from "vee-validate";
import { notifications } from "./modules/notifications";
import api from "../api";
import { jsonIn } from "../utils/snakeCamel";
Vue.use(Vuex);
Vue.use(VeeValidate);

const vuexLocalStorage = new VuexPersist({
  key: "vuex",
  storage: window.localStorage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  //modules: ['Basket,Products'] //DO not use with reducer.
});

export const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  modules: {
    notifications
  },
  state: {
    toursList: [],
    eventsList: [],
    info: undefined,
    menus: [],
    menuNames: [],
    eventAutoComplete: {}
  },
  mutations: {
    addTour(state, payload) {
      Vue.set(state.toursList, payload.index, payload.tour);
    },
    addEvent(state, payload) {
      Vue.set(state.eventsList, payload.index, payload.event);
    },
    addMenu(state, payload) {
      payload.menu["meals"] = [];
      Vue.set(state.menus, payload.index, payload.menu);
    },
    addMeal(state, payload) {
      const menu = state.menus.filter(entry => entry.id === payload.id);
      const meal = payload.meal;
      const meals = menu[0].meals;
      meals.push(meal);
      Vue.set(menu[0], "meals", meals);
    },
    setInfo(state, payload) {
      state.info = Object.assign({}, payload.info);
    },
    resetTours(state) {
      state.toursList = [];
    },
    resetEvents(state) {
      state.eventsList = [];
    },
    resetMenus(state) {
      state.menus = [];
    },
    updateMenusName(state, payload) {
      state.menuNames = payload;
    },
    setAutoCompletes(state, payload) {
      state.eventAutoComplete["page_type"] = payload
        .filter(entry => entry.attr === "page_type")
        .map(entry => entry.key);
      state.eventAutoComplete["category"] = payload
        .filter(entry => entry.attr === "category")
        .map(entry => entry.key);
    }
  },
  getters: {
    toursList: state => {
      return state.toursList;
    },
    eventsList: state => {
      return state.eventsList;
    },
    establishmentInfo: state => {
      return state.info;
    },
    menusList: state => {
      return state.menus;
    },
    menuNames: state => {
      return state.menuNames;
    },
    menuIdFromName: state => name => {
      return state.menus.filter(menu => menu.title === name)[0];
    },
    EventPageTypes: state => {
      return state.eventAutoComplete["page_type"];
    },
    EventCategories: state => {
      return state.eventAutoComplete["category"];
    }
  },
  actions: {
    refreshTours({ commit }) {
      commit("resetTours");
      api.getTours().then(response => {
        response.data.map((tour, index) => {
          commit("addTour", { index: index, tour: jsonIn(tour) });
        });
      });
    },
    refreshEvents({ commit }) {
      commit("resetEvents");
      api.getEvents().then(response => {
        response.data.map((event, index) => {
          commit("addEvent", { index: index, event: jsonIn(event) });
        });
      });
    },
    refreshMenus({ commit, state }) {
      commit("resetMenus");
      api.getMenus().then(response => {
        response.data.map((menu, index) => {
          commit("addMenu", { index: index, menu: jsonIn(menu) });
        });
        api.getMeals().then(resp => {
          resp.data.map(meal => {
            commit("addMeal", { id: meal.menu_id, meal: jsonIn(meal) });
          });
        });
        const menusTitleList = [
          ...new Set(state.menus.map(menu => menu.title))
        ];
        commit("updateMenusName", menusTitleList);
      });
    },
    refreshInfo({ commit }) {
      api.getEstablishment().then(response => {
        commit("setInfo", { info: jsonIn(response.data[0]) });
      });
    },
    fetchAutoCompletes({ commit }) {
      api.getCompletes().then(response => {
        commit("setAutoCompletes", response.data);
      });
    }
  },
  plugins: [vuexLocalStorage.plugin]
});
